"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.fetchByUUID = fetchByUUID;
exports.create = create;
exports.update = update;
exports.remove = remove;
exports.reorderPipelines = reorderPipelines;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _immutable = require("immutable");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = require("crm_data/meta/MetaProducers");

var BASE_URL = "pipelines/v2/pipelines/TICKET";

var uri = function uri() {
  var pipelineId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return BASE_URL + "/" + pipelineId;
};

var getPipelineStageOptions = function getPipelineStageOptions(pipeline) {
  return pipeline.get('stages').map(function (stage) {
    return stage.merge({
      value: stage.get('stageId'),
      text: stage.get('label')
    });
  });
};

var parsePipelines = function parsePipelines(pipelines) {
  var pipelinesMap = pipelines.reduce(function (acc, pipeline) {
    pipeline = pipeline.merge({
      stageOptions: getPipelineStageOptions(pipeline),
      value: pipeline.get('pipelineId')
    });
    return acc.set(pipeline.get('pipelineId'), pipeline);
  }, (0, _immutable.Map)());
  return pipelinesMap.sortBy(function (pipeline) {
    return pipeline.get('displayOrder');
  });
};

function fetch() {
  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(uri());
  };

  return (0, _MetaAPI.queueFetch)(_MetaProducers.TICKET_PIPELINES, fallback, {}, parsePipelines);
}

function fetchByUUID(pipelineId) {
  return (0, _ImmutableAPI.get)(uri(pipelineId));
}

function create(pipeline) {
  return (0, _ImmutableAPI.post)(uri(), pipeline);
}

function update(pipeline) {
  return (0, _ImmutableAPI.put)(uri(pipeline.pipelineId), pipeline);
}

function remove(pipelineId) {
  return (0, _ImmutableAPI.del)(uri(pipelineId));
}

function reorderPipelines(pipelineIds) {
  return (0, _ImmutableAPI.put)(BASE_URL + "/order", pipelineIds);
}